var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#474161"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.5316 21H16.6689C14.556 21 12.8447 22.7219 12.8447 24.8242V47.7695C12.8447 49.8843 14.5686 51.5938 16.6689 51.5938H52.5316C54.6269 51.5938 56.3558 49.8915 56.3558 47.7695V24.8242C56.3558 22.7257 54.6513 21 52.5316 21ZM51.9961 23.5495C51.2147 24.3266 37.7687 37.7019 37.3044 38.1637C36.5821 38.886 35.6218 39.2838 34.6003 39.2838C33.5788 39.2838 32.6185 38.886 31.8938 38.1613C31.5815 37.8507 18.2839 24.6231 17.2045 23.5495H51.9961ZM15.3942 47.2506V25.3447L26.4112 36.3037L15.3942 47.2506ZM17.2061 49.0443L28.2188 38.1017L30.0934 39.9664C31.2973 41.1703 32.8978 41.8332 34.6003 41.8332C36.3027 41.8332 37.9033 41.1703 39.1048 39.9688L40.9818 38.1017L51.9944 49.0443H17.2061ZM53.8064 47.2506L42.7894 36.3037L53.8064 25.3447V47.2506Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.0ef3fdc4.svg";
export { ForwardRef as ReactComponent };